import * as React from "react";
import * as Immutable from "immutable";
import { useEffect } from "react";
import { Field, useFormikContext } from "formik";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
const SelectionTypes = styled.div`
  display: flex;

  div + * {
    margin-left: 10px;
  }
`;
const SelectionTypeOptions = ({ disabled }) => {
  const { t } = useTranslation("enterprise_authentication");
  const {
    values: { teamSelectionType, teamSelection },
    setFieldValue,
    errors,
    setErrors
  } = useFormikContext();
  useEffect(() => {
    if (teamSelectionType === "all" && teamSelection.size >= 1) {
      setFieldValue("teamSelection", Immutable.Set());
    }
  }, [teamSelectionType, teamSelection, setFieldValue]);
  const _onSelectionTypeChange = (event, onChange) => {
    const nextSelectionType = event.target.value;
    if (teamSelectionType !== "all" && nextSelectionType === "all" && teamSelection.size >= 1) {
      if (
        // eslint-disable-next-line no-alert
        window.confirm(t("directory_services.selection_type_options.confirm_all"))
      ) {
        onChange(event);
      }
      return;
    }
    if (teamSelectionType !== "all" && nextSelectionType === "all" && (errors == null ? void 0 : errors.teamSelection)) {
      setErrors({ ...errors, teamSelection: void 0 });
      return;
    }
    onChange(event);
  };
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "teamSelectionType",
      label: t("directory_services.selection_type_options.label"),
      disabled,
      help: t("directory_services.selection_type_options.help"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(Field, { name: "teamSelectionType" }, ({ field: { name, onChange, onBlur, value } }) => /* @__PURE__ */ React.createElement(SelectionTypes, null, /* @__PURE__ */ React.createElement(
      Input,
      {
        checked: value === "all",
        formGroupClassName: "",
        id: name,
        disabled,
        label: t("directory_services.selection_type_options.all_groups"),
        onBlur,
        onChange: (e) => _onSelectionTypeChange(e, onChange),
        type: "radio",
        value: "all"
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        checked: value === "include",
        formGroupClassName: "",
        disabled,
        id: name,
        label: t("directory_services.selection_type_options.include_selected"),
        onBlur,
        onChange: (e) => _onSelectionTypeChange(e, onChange),
        type: "radio",
        value: "include"
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        checked: value === "exclude",
        formGroupClassName: "",
        id: name,
        disabled,
        label: t("directory_services.selection_type_options.exclude_selected"),
        onBlur,
        onChange: (e) => _onSelectionTypeChange(e, onChange),
        type: "radio",
        value: "exclude"
      }
    )))
  );
};
export default SelectionTypeOptions;
